export default __webpack_public_path__ + "static/superreturn-a826488d6177273b4661d22ced1fafdb.png";